import React from 'react';

function Mobile() {
  return <div>Locations</div>;
}

export default Mobile;
